/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import mixins from '../../assets/styles/mixins.scss';

const cssVarEntries = Object.entries(mixins).filter(
  ([key, value]) => typeof value === 'string'
    && !key.endsWith('-min')
    && !key.endsWith('-max')
    && !key.includes('-media')
    && !key.includes('-maxwidth')
    && !key.includes('-')
);

const cssVariables = cssVarEntries.reduce((acc, [key, value]) => {
  acc[`--${key}`] = value;

  return acc;
}, {});

const ThemeVariablesRoot = ({ children }) => (
  <Box className="aet-theme-root" sx={cssVariables}>
    {children}
  </Box>
);

ThemeVariablesRoot.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

ThemeVariablesRoot.defaultProps = {
  children: null
};

export default ThemeVariablesRoot;
